import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { Loader } from 'rsuite';
import { API_BASE } from '../../helpers/authFetch';

const GRID_STYLES = {
  container: {
    padding: '16px 0',
    marginTop: '12px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
    gap: '12px',
    maxHeight: '800px',
    overflowY: 'auto',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  gridMobile: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))',
    gap: '10px',
    maxHeight: '600px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  setItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 8px',
    cursor: 'pointer',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    backgroundColor: '#f9f9f9',
  },
  setItemHover: {
    backgroundColor: '#e3f2fd',
    borderColor: '#2196f3',
    transform: 'scale(1.05)',
  },
  setIcon: {
    width: '48px',
    height: '48px',
    objectFit: 'contain',
    marginBottom: '8px',
  },
  setName: {
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    color: '#333',
    marginBottom: '4px',
    wordBreak: 'break-word',
  },
  setCode: {
    fontSize: '10px',
    color: '#666',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
};

const SetSymbolGrid = ({ onSetClick }) => {
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSets = async () => {
      try {
        const response = await fetch(`${API_BASE}/sets/`);
        const data = await response.json();
        setSets(data);
      } catch (error) {
        console.error('Failed to fetch sets:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSets();
  }, []);

  if (loading) {
    return (
      <div style={GRID_STYLES.loaderContainer}>
        <Loader content="Loading sets..." />
      </div>
    );
  }

  if (sets.length === 0) {
    return (
      <div style={GRID_STYLES.container}>
        <p style={{ color: '#666', textAlign: 'center' }}>No sets available</p>
      </div>
    );
  }

  const filteredSets = sets.filter(
    (set) => !['memorabilia', 'token', 'promo'].includes(set.set_type)
  );

  const gridStyle = {
    ...GRID_STYLES.grid,
    ...(isMobile ? GRID_STYLES.gridMobile : {}),
  };

  return (
    <div style={GRID_STYLES.container}>
      <div style={gridStyle}>
        {filteredSets.map((set) => (
          <div
            key={set.id}
            style={GRID_STYLES.setItem}
            onClick={() => onSetClick(set)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSetClick(set);
              }
            }}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, GRID_STYLES.setItemHover);
            }}
            onMouseLeave={(e) => {
              Object.assign(e.currentTarget.style, GRID_STYLES.setItem);
            }}
            role="button"
            tabIndex={0}
            title={set.name}
          >
            {set.icon_svg_uri && (
              <img
                src={set.icon_svg_uri}
                alt={set.name}
                style={GRID_STYLES.setIcon}
              />
            )}
            <div style={GRID_STYLES.setName}>{set.name}</div>
            <div style={GRID_STYLES.setCode}>{set.code}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SetSymbolGrid;
